import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErrorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("demo@serabi.com");
  const [password, setPassword] = useState("demo123");
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "Sannatech - Login";
  }, []);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 bg-[#003399] p-12 text-white relative overflow-hidden">
        <div className="flex items-center gap-2.5 relative z-10">
          <img src="/logo.png" alt="Serabi" className="h-14 object-contain" />
        </div>
        <div className="relative z-10">
          <h1 className="font-heading text-5xl font-extrabold tracking-tight leading-tight mb-4">
            WhatsApp Business,<br />dikelola dengan <span className="text-[#FFDA1A]">rapi.</span>
          </h1>
          <p className="text-white/70 text-base max-w-md">
            Kelola channel, kontak, template, dan percakapan WhatsApp Business Anda dalam satu management system.
          </p>
        </div>
        <div className="text-white/50 text-sm relative z-10">© 2026 Serabi. Management System.</div>
        <div className="absolute -right-28 -bottom-28 w-96 h-96 rounded-full bg-[#FFDA1A]" />
        <div className="absolute right-40 top-16 w-40 h-40 rounded-full bg-white/5" />
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-6 bg-white">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2.5 mb-8">
            <img src="/logo.png" alt="Serabi" className="h-12 object-contain" />
          </div>
          <h2 className="font-heading text-3xl font-bold text-[#111111] mb-2">Masuk</h2>
          <p className="text-sm text-[#484848] mb-8">Gunakan email dan password Anda untuk mengakses workspace.</p>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
            </div>
            {error && <p className="text-sm text-[#CC0008]" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#FFDA1A] hover:bg-[#F5CE00] text-[#111111] font-bold" data-testid="login-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Masuk"}
            </Button>
          </form>

          <div className="mt-6 p-3 rounded-[4px] bg-[#F5F5F5] text-xs text-[#484848]">
            Demo: <span className="font-mono">demo@serabi.com</span> / <span className="font-mono">demo123</span>
          </div>
        </div>
      </div>
    </div>
  );
}
